export enum StudentEventType {
  SESSION_STARTED = 'session_started',
  SETTING_CHANGED = 'setting_changed',
}

type StudentEventActor =
  | {
      type: 'student' | 'system';
    }
  | {
      type: 'educator';
      name: string;
    };

interface BaseStudentEvent {
  id: string;
  organisationId: string;
  studentId: string;
  createdAt: number;
  actor: StudentEventActor;
  /** Set `nestedUnderSessionId` for in-game events to nest
   * the event under the session in activity feed.*/
  nestedUnderSessionId: string | null;
}

type SessionStartedEvent = {
  type: StudentEventType.SESSION_STARTED;
  sessionId: string;
};

export type SettingChangedLocation =
  | 'learner-details'
  | 'game'
  | 'org-wide-settings'
  | 'bulk-settings'
  | 'group-settings';

export interface SettingChange {
  setting: string;
  oldValue: string;
  newValue: string;
}
type SettingChangedEvent_v1 = {
  type: StudentEventType.SETTING_CHANGED;
  changes: SettingChange[];
};
type SettingChangedEvent_v2 = SettingChangedEvent_v1 & {
  location: SettingChangedLocation;
};
export type SettingChangedEvent =
  | SettingChangedEvent_v1
  | SettingChangedEvent_v2;

export type StudentEvent = BaseStudentEvent &
  (SessionStartedEvent | SettingChangedEvent);

export type CreateStudentEvent = Omit<BaseStudentEvent, 'id'> &
  (SessionStartedEvent | SettingChangedEvent_v2);
